module.exports = __webpack_public_path__ + "img/card-blog6.7e4fdf9a.jpg";